import { render, staticRenderFns } from "./main_results.vue?vue&type=template&id=fa90e094&scoped=true"
import script from "./main_results.vue?vue&type=script&lang=js"
export * from "./main_results.vue?vue&type=script&lang=js"
import style0 from "./main_results.vue?vue&type=style&index=0&id=fa90e094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa90e094",
  null
  
)

export default component.exports